import { render } from "./table.vue?vue&type=template&id=80e4367c&scoped=true"
import script from "./table.vue?vue&type=script&lang=ts"
export * from "./table.vue?vue&type=script&lang=ts"

import "./table.vue?vue&type=style&index=0&id=80e4367c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-80e4367c"

export default script